import { useContext } from "react";
import { useProSidebar } from "react-pro-sidebar";

import classes from "../Home/Home.module.css";
import authContext from "../../../../AuthContext/authContext";

const Header = () => {
  const ctx = useContext(authContext);
  // const activeCompany = useSelector((state) => state.appData.activeCompany);
  // console.log("activeCompany", activeCompany.ppoData);
  // const activePPU = activeCompany.ppoData.find((item) => item.isActive === true);
  // console.log("activePPU", activePPU);
  const { collapseSidebar, collapsed } = useProSidebar();
  return (
    <>
      <div
        className={classes.topHeader}
        style={{
          justifyContent:
            window.screen.width <= 1100 ? "space-between" : "flex-end",
          position: window.screen.width <= 1100 ? "sticky" : "static",
          top: window.screen.width <= 1100 ? "0" : "",
          zIndex: "11",
        }}
      >
        {window.screen.width <= 1100 && (
          <div className={classes.hamburger} onClick={() => collapseSidebar()}>
            <img
              src={require("../../../../assets/img/admin-images/hamburger.png")}
            />
          </div>
        )}
        <div
          className={classes.logout}
          style={{
            display: window.screen.width <= 1100 ? "none" : "flex",
          }}
          onClick={() => ctx.logout()}
        >
          Logout
        </div>
      </div>
    </>
  );
};

export default Header;
